import { render, staticRenderFns } from "./UpdateProfile.vue?vue&type=template&id=4f3cc3fa&scoped=true"
import script from "./UpdateProfile.vue?vue&type=script&lang=js"
export * from "./UpdateProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3cc3fa",
  null
  
)

export default component.exports